module.exports = __webpack_public_path__ + "img/vishay.7375e2fe.jpg";